import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ThemeState {
  themeId: string;
  sidebarDark: boolean;
  sidebarBg: string;
  sidebarStroke: string;
  setTheme: (id: string, sidebarDark: boolean, sidebarBg: string, sidebarStroke: string) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      themeId: "default",
      sidebarDark: false,
      sidebarBg: "",
      sidebarStroke: "",
      setTheme: (id, sidebarDark, sidebarBg, sidebarStroke) =>
        set({ themeId: id, sidebarDark, sidebarBg, sidebarStroke }),
    }),
    { name: "gymviz.sidebar-theme" }
  )
);
